(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[245],{

/***/ "0a2G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// EXTERNAL MODULE: ./src/client/components/widgets/product-strengths/ProductStrengths.jsx
var ProductStrengths = __webpack_require__("WeoX");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/lines/product-strengths-line/ProductStrengthsLine.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ProductStrengthsLine_ProductStrengthsLine = function ProductStrengthsLine(_ref) {
  var displayLoadMore = _ref.displayLoadMore,
      id = _ref.id,
      items = _ref.items,
      isExclusiveCollection = _ref.isExclusiveCollection,
      resort = _ref.resort,
      title = _ref.title;

  if (isEmpty_default()(items) || !resort) {
    return null;
  }

  var isProductExclusiveCollection = resort.isExclusiveCollection,
      isJoyview = resort.isJoyview;
  var isEC = isProductExclusiveCollection || isExclusiveCollection;
  var colorDef = isEC ? colors["a" /* COLORS */].ULTRAMARINE : colors["a" /* COLORS */].BLACK;
  var color = isJoyview ? colors["a" /* COLORS */].BLUE_WAVE : colorDef;
  var filledItems = items.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      color: color,
      trackingData: {
        actionGA: 'productStrenghtsBanner',
        labelGA: item.label
      }
    });
  });
  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    "data-testid": "productStrenghts",
    id: id
  }, __jsx(LineTitle["a" /* LineTitle */], null, title), __jsx(ProductStrengths["a" /* ProductStrengths */], {
    displayLoadMore: displayLoadMore,
    isExclusiveCollection: isEC,
    items: filledItems
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-strengths/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductStrengthsLine_ProductStrengthsLine);

/***/ })

}]);